export default {
	workers: {
		exportMenu: {
			caption: 'Export menu',
			type_interval: 'Pays interval',
			type_lastPays: 'Last pays',
			type_latestMonths: 'Latest monthes',
			typeLabel: 'Type export'
		},
		debt: 'Debt',
		mark: 'Mark',
		subtracted: 'Subtracted',
		created_at: 'Created at',
		hourly_rate: 'Hourly rate',
		number_hours: 'Number of hours',
		pay: 'Pay',
		worker_home_address: 'worker home address',
		document_number: 'Document number',
		filename: 'Filename',
		fields: 'Fields',
		avatar: 'Avatar',
		title: 'Workers',
		add_worker: 'Add worker',
		titul: 'Titul',
		started_at: 'Start Date',
		ended_at: 'End Date',
		id: 'Id',
		firstname: 'Firstname',
		lastname: 'Lastname',
		person_lastname: 'Person Lastname',
		person_firstname: 'Person Firstname',
		person_birth_date: 'Person Birth Date',
		person_gender: 'Person gender',
		gender: 'Gender',
		male: 'Male',
		female: 'Female',
		actions: 'Actions',
		number: 'Number',
		type: 'Type',
		issuer: 'Issuer',
		issued_at: 'Issuer Date Start',
		invalid_at: 'Issuer Date End',
		created: 'Created',
		updated: 'Updated',
		work_permit_number: 'Permit Number',
		work_permit_date: 'Permit Date',
		cz_isco: 'CZ-ISCO',
		cz_nace: 'CZ-NACE',
		job_start: 'Job Start',
		job_end: 'Job End',
		job_form: 'Job Form',
		salary_min: 'Salary Min',
		salary_max: 'Salary Max',
		sign_date: 'Sign Date',
		first_job: 'First Job',
		active_job: 'Active Job',
		search: 'Search',
		worker: 'Worker',
		birth_date: 'Birth Date',
		citizenship: 'Citizenship',
		civil_status: 'Civil Status',
		confirm_message_scan: 'Do you really want to delete the scan?',
		confirm_message_job: 'Do you really want to delete the job?',
		confirm_message_worker: 'Do you really want to delete the worker?',
		confirm_message_pay: 'Do you really want to delete the pay?',
		upload_scan: 'Upload new scan',
		scan_types: 'Scan Types',
		scan_type: 'Scan type',
		add_worker_skan: 'Add Worker Scan',
		number_document: 'Number Document',
		job: 'Job',
		employer: 'Employer',
		add_job: 'Add Job',
		parttime: 'Parttime',
		fulltime: 'Fulltime',
		employer_required: 'employer is required',
		start_end_valid: 'date star > date end',
		merried: 'Merried',
		not_merried: 'Not merried',
		save_general: 'Save General',
		edu_end: 'Education End Date',
		edu_start: 'Education Start Date',
		edu_institution_name: 'Institute Name',
		edu_type: 'Education Type',
		education: 'Education',
		insurance_start_at: 'Insurance End Date',
		insurance_end_at: 'Insurance Start Date',
		insurance_number: 'Insurance Number',
		insurance: 'Insurance',
		birth_place: 'Birth Place',
		general: 'General',
		contacts: 'Contacts',
		deleting_contact: 'Confirm Deleting Contact',
		confirm_contact: 'Do you really want delete contact?',
		add_contact: 'Add Contact',
		negative_salary: 'salary is negative',
		confirm_salary:
			'Do you really want to pay a salary {salary} to {workerName}',
		confirm_salary_title: 'Confirm Salary',
		confirm_pay_salary: 'Do you really want to pay a salary?',
		pay_salary: 'PAY SALARY',
		to_pay: 'To Pay',
		prepayment: {
			type_prepay: 'Prepayment',
			type_accommodation: 'Accommodation',
			type_fare: 'Fare',
			type_premium: 'Premium',
			confirm_payment_title_prepay: 'Confirm Prepayment',
			confirm_payment_title_premium: 'Confirm Premium',
			confirm_payment_title_accommodation: 'Confirm Accommodation',
			confirm_payment_title_fare: 'Confirm Fare',
			confirm_payment_prepay: 'Do you really want to prepayment?',
			confirm_payment_accommodation: 'Do you really want to accommodation?',
			confirm_payment_fare: 'Do you really want to fare?'
		},
		confirm_prepayment:
			'Do you really want to pay a prepayment {amount} to {workerName} with comment {comment}',
		salary: 'Salary',
		name: 'Name',
		roles: 'Roles',
		counts_day_hours: 'Count Day/Hours',
		rate: 'Rate',
		rate_count_day: 'Rate and Count Day/Hours',
		payment: 'Payment',
		issue_payment: 'Issue Payment',
		pay: 'PAY',
		date_start: 'Date Start',
		date_end: 'Date End',
		amount: 'Amount',
		comment: 'Comment',
		add_comment: 'Add comment',
		landlord: 'Landlord',
		apartment_address: 'Apartment Address',
		room_number: 'Room №',
		confirm_accommodation: 'Do you really want to delete the accommodation?',
		accommodation: 'Accommodation',
		accommodations: 'Accommodations',
		add_accommodation: 'Add Accommodation',
		landlord_required: 'landlord is required',
		email: 'Email',
		main: 'Main',
		user: 'User',
		date: 'Date',
		sum_salary: 'Sum Salary',
		sum_prepay: 'Sum Prepay',
		employer_name: 'Employer Name',
		street_names: 'Street Names',
		landlord_name: 'Landlord Name',
		scan: 'Scan',
		rodni_chisla: 'Rodni Chisla',
		passport_number: 'Passport Number',
		agency_name: 'Agency Name',
		export_finance_report: 'Export Financial Report',
		address: 'Address',
		tab: {
			general: 'General',
			jobs: 'Jobs',
			scans: 'Scans',
			finance: 'Finance',
			comments: 'Comments',
			history: 'History',
			accommodation: 'Accommodation'
		},
		filters: {
			type_label: 'Filter type',
			date_type_label: 'Date type',
			byAgency: 'Filter by Agency',
			byEmployer: 'Filter by Employer',
			byDateYear: 'Filter by year',
			byDateMonth: 'Filter by month',
			byDateWeek: 'Filter by week',
			exportButton: 'Export',
			type_employer: 'By employer',
			type_agency: 'By agency',
			type_month: 'By month',
			type_week: 'By week'
		}
	},
	templates: {
		dialog_users_caption: 'Enter email',
		dialog_users_submit: 'Create',
		dialog_worker_caption: 'Choose user',
		dialog_worker_user: 'User',
		download_file: 'Download File',
		download_prev: 'Download Preview',
		download_original: 'Download Original',
		available_fields: 'Available fields',
		config: 'Config',
		loading: 'loading...',
		doc_templates: 'Document templates',
		template: 'Template',
		templates: 'Templates',
		save_changes: 'save changes',
		you_sure: 'Are you sure?',
		select_template: 'select new template'
	},
	login: {
		login: 'Login',
		email: 'Email',
		password: 'Password',
		login_form: 'Login form',
		logOut: 'Log out'
	},
	contacts: [
		{ type: 'vib', text: 'viber' },
		{ type: 'tg', text: 'telegram' },
		{ type: 'phone', text: 'phone' },
		{ type: 'skyp', text: 'skype' },
		{ type: 'email', text: 'email' }
	],
	contacts_agency: [
		{ type: 'person_email', text: 'Person Email' },
		{ type: 'person_phone', text: 'Person Phone' },
		{ type: 'office_email', text: 'Office Email' },
		{ type: 'office_phone', text: 'Office Phone' }
	],
	navigation: {
		dashboard: 'Dashboard',
		workers: 'Workers',
		worker: 'Worker',
		employers: 'Employers',
		employer: 'Employer',
		landlords: 'Landlords',
		landlord: 'Landlord',
		users: 'Users',
		user: 'User',
		login: 'Login',
		finance_reports: 'Financial reports',
		user_finance_pays: 'User finance pays',
		history: 'History',
		templates: 'Templates',
		template: 'Template',
		settings: 'Settings',
		agencies: 'Agencies',
		personal_finance: 'Personal finance',
		agency: 'Agency',
		database: 'Database',
		settings_title: 'Settings',
		not_found: 'Not found'
	},
	payments_types: {
		type_salary: 'Salary',
		type_prepay: 'Prepay',
		type_debt: 'Debt',
		type_accommodation: 'Accommodation',
		type_fare: 'Fare',
		type_premium: 'Premium',
		type_zp: 'Health insurance',
	},
	personal_finance: {
		show_personal_finance: 'Show personal finance',
		output: 'Output pay',
		debt: 'Debt',
		premium: 'Premium',
		input: 'Input pay',
		pay: 'Pay',
		workers_pay: 'Worker Pay',
		pay_accommodation: 'Accommodation',
		pay_fare: 'Fare',
		add_input_button: 'Add input pay',
		add_output_button: 'Add output pay',
		transfer_button: 'Transfer',
		dialog_caption_input: 'Payment input',
		dialog_caption_output: 'Payment output',
		amount: 'Amount',
		comment: 'Comment',
		confirm_message_pay: 'Do you really want to delete the finance?',
		finance: 'finance',
		transfer: 'Transfer',
		balance: 'Balance',
		balance_by_period: 'Balance by period',
		prepay_users: 'Prepay users',
		transfer_user_name: 'Transfer user name',
		user_name: 'Name',
		id: 'Id',
		created_at: 'Created_at',
		actions: 'Actions',
		category: 'Category',
	},
	payment_category: {
		caption: "Payment Category",
	},
	employers: {
		header: 'Employer info',
		employers: 'Employers',
		employer: 'Employer',
		name: 'Name',
		ico: 'Ico',
		dic: 'Dic',
		person_titul1: 'Person Titul 1',
		person_titul2: 'Person Titul 2',
		person_rodnyChisla: 'Person Rodny Chisla',
		save_employer: 'Save Employer',
		add_employer: 'Add Employer'
	},
	history: {
		history: 'History',
		new_field: 'Name Field',
		old: 'Old',
		new: 'New',
		employer_id: 'Employer Id'
	},
	landlords: {
		header: "Landlord info",
		landlords: 'Landlords',
		landlord: 'Landlord',
		titul_first: 'Titul First',
		titul_second: 'Titul Second',
		person_document_id: 'Document Id',
		person_document_issuer: 'Document Issuer',
		save_landlord: 'Save Landlord',
		add_landlord: 'Add Landlord'
	},
	address: {
		office_address: 'Office Address',
		work_address: 'Work Address',
		apartment_address: 'Apartment Address',
		person_address: 'Person Address',
		landlord_apartment_address: 'Landlord Apartment Address',
		landlord_person_address: 'Landlord Person Address',
		employer_office_address: 'Employer Office Address',
		employer_work_address: 'Employer Work Address',
		user_home_address: 'Home address',
		agency_address: 'Office Address',
		work_address_id: 'Work Address Id',
		actions: 'Actions',
		country: 'Country',
		district: 'District',
		region: 'Region',
		city: 'City',
		index: 'Index',
		smirovaci: 'Smirovaci',
		street: 'Street',
		building_number: 'Building Number',
		address: 'Address',
		add_address: 'Add Address',
		confirm_address: 'Do you really want to delete the Address?'
	},
	user: {
		header: "User info",
		users: 'Users',
		user: 'User',
		passport: 'Passport',
		created_at: 'Created At',
		updated_at: 'Updated At',
		add_user: 'Add User',
		new_password: 'New Password',
		repeat_password: 'Repeat Password',
		password: 'Password',
		change_password: 'Change Password',
		password_not_match: 'Passwords do not match',
		confirm_password: 'Do you really want to change the password?',
		confirm_password_title: 'Confirm Change Password',
		save_user: 'Save user'
	},
	roles: {
		admin: 'admin',
		manager: 'manager',
		can_prepay: 'canPrepay'
	},
	common: {
		email: 'Email',
		type_contact: 'Type contact',
		template_name: 'Template name',
		site_title: 'PPA online',
		site_name: 'PPA&nbsp;<span class="font-weight-light">online</span>',
		close: 'Close',
		save: 'Save',
		yes: 'Yes',
		no: 'No',
		delete: 'Delete',
		edit: 'Edit',
		download: 'Download',
		confirm: 'Confirm',
		cancel: 'Cancel',
		ok: 'Ok',
		value: 'Value',
		name: 'Name',
		comment: 'Comment',
		sum: 'Sum',
		text: 'Text',
		add: 'Add',
		all: 'All',
		no_result: 'Your search for "{search}" found no results.',
		item: 'Item',
		add_new: 'Add New',
		not_found: 'Not Found',
		enabled: 'Enabled',
		disabled: 'Disabled',
		no_internet: 'NO INTERNET NETWORK',
		created: 'Created',
		updated: 'Updated',
		deleted: 'Deleted',
		main_search: 'Search for your favorite',
		email_required: 'E-mail is required',
		email_valid: 'E-mail must be valid',
		password_required: 'Password is required',
		not_found_title: 'Oh no, bad luck!',
		not_found_text:
			'The page you’re looking for could have been deleted or never have existed.',
		field_required: 'Field is required',
		confirm_message_avatar: 'Do you really want to delete the avatar?',
		confirm_message_comment: 'Do you really want to delete the comment?',
		upload: 'Upload',
		insurance_company: 'Insurance Company',
		history_dates: 'For the current dates there is no history',
		find: 'Find',
		jobs: 'Jobs',
		none: 'None',
		filter_by_agency: 'Filter by Agency',
		gender_male: 'Male',
		gender_female: 'Female'
	},
	notifications: {
		saved: '{type} successfully saved',
		added: '{type} successfully added',
		updated: '{type} successfully updated',
		deleted: '{type} successfully deleted',
		upload: '{type} successfully upload',
		created: '{type} successfully created',
		changed: '{type} successfully changed',
		server_error: 'Server Error - Reload Page',
		client_error: 'Client Error - Reload Page',
		no_connection: 'No connection Internet'
	},
	agencies: {
		header: "Agency info",
		person_firstname: 'Person Firstname',
		person_lastname: 'Person Lastname',
		agencies: 'Agencies',
		add_agency: 'Add Agency',
		id: 'Id',
		name: 'Name',
		ico: 'ICO',
		dic: 'DIC',
		company_number: 'Company Number',
		actions: 'Actions',
		agency: 'Agency',
		social_security_number: 'Social Security Number',
		spisova_znachka: 'Spisova Znachka',
		mpsv: 'MPSV',
		save_agency: 'Save agency',
		notAgency: '<no agency>'
	},
	reports: {
		all: 'All',
		users: 'Users',
		workers: 'Workers'
	},
	$vuetify: {
		dataIterator: {
			pageText: '{0}-{1} of {2}',
			rowsPerPageAll: 'All'
		},
		dataTable: {
			rowsPerPageText: 'Items per page:',
			rowsPerPageAll: 'All'
		},
		noDataText: 'No Data Available'
	}
}
